import { Alert, DatePicker, Flex, Spin, Typography } from 'antd'
import { FC, useState } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import styled from 'styled-components'
import PageLayout from '../../components/page-layout/page-layout'
import useErrorModal from '../../hooks/api/use-error-modal'
import { formatMetric } from '../profile/printer-content/helpers/calc-printer-monthly-stats'
import ShiftVolumeTable from './components/shift-volume-table'
import { SHIFT_LABELS } from './constants/shift-grid'
import useVolumeSummary from './hooks/use-volume-summary'

const Toolbar = styled(Flex)`
    margin-bottom: 16px;
`

const MonthPickerWrap = styled.div`
    width: 140px;

    .ant-picker {
        width: 100%;
    }
`

const Totals = styled(Flex)`
    margin-bottom: 24px;
`

const TotalCard = styled.div`
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    padding: 12px 16px;
    min-width: 140px;
`

const TotalLabel = styled(Typography.Text)`
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
`

const VolumeSummaryPage: FC = () => {
    const [month, setMonth] = useState<Dayjs>(() => dayjs())
    const { summary, isLoading, isError, error, hasData } = useVolumeSummary(month)

    useErrorModal({ isError, error }, 'Не удалось загрузить сводку по объему')

    return (
        <PageLayout title='Сводка по объему' scrollableContent>
            <Spin spinning={isLoading}>
                <Toolbar align='center' gap={12}>
                    <Typography.Text>Месяц:</Typography.Text>
                    <MonthPickerWrap>
                        <DatePicker
                            picker='month'
                            value={month}
                            onChange={value => value && setMonth(value)}
                            allowClear={false}
                        />
                    </MonthPickerWrap>
                </Toolbar>

                {isError && !hasData ? (
                    <Alert type='error' message='Не удалось загрузить сводку по объему' />
                ) : (
                    <>
                        <Totals gap={12} wrap='wrap'>
                            <TotalCard>
                                <TotalLabel type='secondary'>Объем итого</TotalLabel>
                                <Typography.Text strong>
                                    {summary.totalVolume == null
                                        ? '—'
                                        : formatMetric(summary.totalVolume)}
                                </Typography.Text>
                            </TotalCard>
                            {summary.shifts.map(shift => (
                                <TotalCard key={shift.shift}>
                                    <TotalLabel type='secondary'>
                                        {SHIFT_LABELS[shift.shift]}
                                    </TotalLabel>
                                    <Typography.Text strong>
                                        {shift.volume == null ? '—' : formatMetric(shift.volume)}
                                    </Typography.Text>
                                </TotalCard>
                            ))}
                        </Totals>

                        {summary.shifts.map(shift => (
                            <ShiftVolumeTable
                                key={shift.shift}
                                shift={shift}
                                title={SHIFT_LABELS[shift.shift]}
                            />
                        ))}
                    </>
                )}
            </Spin>
        </PageLayout>
    )
}

export default VolumeSummaryPage
